// TODO: delete this component when useImprovedBrandFiltering FF removed
import { gql, useLazyQuery, useMutation } from '@apollo/client'
import Typography from '@mui/material/Typography'
import useFilter from '@promoboxx/use-filter'
import I18n from 'i18n-js'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'

import { currentRetailerAccountSelector } from '../../stores/app/selectors'
import { currentRetailerIdSelector } from '../../stores/retailers/selectors'
import Loading from '../shared/Loading'
import ShowMoreButton from '../shared/ShowMoreButton'

import CampaignCard from './CampaignCard'
import CampaignGroupHeader from './CampaignGroupHeader/index'

const useStyles = makeStyles()(() => ({
  results: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: '24px',
  },
  noResults: {
    width: '100%',
    textAlign: 'center',
  },
  showMore: {
    width: '100%',
  },
}))

const CONTENT_DISCOVERY = gql`
  query LegacyContentDiscoveryContentPage(
    $resourceType: String!
    $resourceId: ID!
    $params: ContentDiscoveryParams
  ) {
    getContentDiscovery(
      resourceType: $resourceType
      resourceId: $resourceId
      params: $params
    ) {
      data {
        id
        brand_id
        brand {
          id
          logo_url
          slug
        }
        post_id
        content_hash
        channel_source
        channel_type
        content_type
        message
        title
        description
        content_created_at
        image_url
        video_url
        url
        enabled
        created_at
        update_at
      }
      paging {
        total_results
      }
    }
  }
`

const CREATE_CONTENT_DISCOVERY_CAMPAIGN = gql`
  mutation LegacyCreateContentDiscoveryCampaign(
    $contentDiscoveryId: ID!
    $retailerId: ID!
  ) {
    createContentDiscoveryCampaign(
      retailerId: $retailerId
      contentDiscoveryId: $contentDiscoveryId
    ) {
      id
      creative_path
    }
  }
`

const Results = ({ campaigns, retailerAccount }) => {
  const [createContentDiscoveryCampaign] = useMutation(
    CREATE_CONTENT_DISCOVERY_CAMPAIGN,
  )
  let results = []
  for (let i = 0; i < campaigns.length; i += 1) {
    const campaign = { ...campaigns[i] }
    const retailer = retailerAccount.retailers.find(
      (retailer) => String(retailer.brand_id) === String(campaign.brand_id),
    )
    let onViewOrActivate = (event) => {
      event.preventDefault()
      return createContentDiscoveryCampaign({
        variables: {
          contentDiscoveryId: campaign.id,
          retailerId: retailer.id,
        },
      })
        .then((response) => {
          window.location = `/#/${retailerAccount.slug}/${campaign.brand.slug}/campaigns/${response.data.createContentDiscoveryCampaign.creative_path}/activate`
        })
        .catch((error) => {
          console.error(error)
        })
    }

    let campaignCardProps = {
      cardImage: campaign.image_url,
      brandLogo: campaign.brand.logo_url,
      description: campaign.description || campaign.message,
      title: campaign.title,
      channels: [
        {
          type: 'facebook',
        },
        {
          type: 'instagram',
        },
        {
          type: 'twitter',
        },
        {
          type: 'downloadables',
        },
      ],
    }

    results.push(
      <CampaignCard
        {...campaignCardProps}
        index={i}
        key={`content-discovery-${campaign.id}-${i}`}
        onViewOrActivate={onViewOrActivate}
        type={'contentDiscovery'}
      />,
    )
  }
  return results
}

const ContentDiscovery = () => {
  const { classes } = useStyles()
  const [campaigns, setCampaigns] = useState([])
  const retailerId = useSelector(currentRetailerIdSelector)
  const retailerAccount = useSelector(currentRetailerAccountSelector)
  const [getContentDiscovery, { data, error, refetch, called, loading }] =
    useLazyQuery(CONTENT_DISCOVERY)

  const showMoreButtonHandler = () => {
    filterInfo.setPage(filterInfo.filterInfo.page + 1)
  }

  const filterInfo = useFilter('content.content_discovery', {
    shouldForceRunOnMount: true,
    defaultFilterInfo: {
      filter: {
        channel_type: null,
      },
      pageSize: 6,
    },
    onChange(filterInfo) {
      let variables = {
        resourceId: retailerId ? retailerId : retailerAccount.id,
        resourceType: retailerId ? 'retailers' : 'retailer_accounts',
        params: {
          per_page: 6,
          offset: filterInfo.offset,
          sort_column: 'content_discovery_items.content_created_at',
          sort_direction: 'desc',
          filterParams: {
            enabled: [1],
          },
          fields: ['brand'],
        },
      }
      if (filterInfo.filter.channel_type) {
        variables.params.filterParams.channel_type = [
          filterInfo.filter.channel_type,
        ]
      }
      return (called ? refetch(variables) : getContentDiscovery({ variables }))
        .then((response) => {
          return {
            filterInfo: {
              totalResults:
                (response.data &&
                  response.data.getContentDiscovery &&
                  response.data.getContentDiscovery.paging.total_results) ||
                0,
            },
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
  })

  useEffect(() => {
    if (called) {
      setCampaigns([])
      filterInfo.updateFilter({
        retailerId,
        retailerAccountId: retailerAccount.id,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retailerId, retailerAccount.id])

  useEffect(() => {
    if (data && data.getContentDiscovery && data.getContentDiscovery.data) {
      setCampaigns([...campaigns, ...data.getContentDiscovery.data])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (error) {
      setCampaigns([])
      console.error(error)
    }
  }, [error])

  if (called) {
    return (
      <CampaignGroupHeader
        count={campaigns.length ? filterInfo.filterInfo.totalResults : 0}
        title={I18n.t('content.recommendedContent')}
      >
        {loading ? (
          <Loading />
        ) : (
          <div className={classes.results}>
            {campaigns.length ? (
              <Results
                campaigns={campaigns}
                retailerAccount={retailerAccount}
              />
            ) : (
              <Typography className={classes.noResults}>
                {I18n.t('content.noContentDiscoveryFound')}
              </Typography>
            )}
            <div className={classes.showMore}>
              <ShowMoreButton
                loading={filterInfo.isLoading}
                numberShown={
                  filterInfo.filterInfo.page * filterInfo.filterInfo.pageSize
                }
                onClick={showMoreButtonHandler}
                total={filterInfo.filterInfo.totalResults + 1}
              />
            </div>
          </div>
        )}
      </CampaignGroupHeader>
    )
  } else {
    return null
  }
}

export default ContentDiscovery
